import {
  memo,
  FC,
  useState,
  useCallback,
  ChangeEvent,
  FocusEventHandler,
  KeyboardEventHandler,
  LegacyRef,
  useRef,
} from 'react';
import TextArea from '../../../components/TextArea';

interface AutoUpdateTextAreaProps {
  onUpdate: (newValue: string) => void;
  value?: string;
  containerClass?: string;
  label?: string;
}

const enterKey = 13;

export const AutoUpdateTextArea: FC<AutoUpdateTextAreaProps> = memo(({ onUpdate, value, containerClass, label }) => {
  const [displayedValue, setDisplayedValue] = useState(value || '');
  const inputRef = useRef<HTMLTextAreaElement>();

  const onChange = useCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    setDisplayedValue(event.target.value);
  }, []);

  const onBlur = useCallback<FocusEventHandler<HTMLTextAreaElement>>(() => {
    onUpdate(displayedValue);
  }, [onUpdate, displayedValue]);

  const onKeyUp = useCallback<KeyboardEventHandler<HTMLTextAreaElement>>((event) => {
    if (event.keyCode === enterKey) {
      event.preventDefault();
      inputRef.current?.blur();
    }
  }, []);

  return (
    <TextArea
      containerClass={containerClass}
      label={label}
      value={displayedValue}
      onChange={onChange}
      textAreaProps={{ onBlur, onKeyUp, ref: inputRef as LegacyRef<HTMLTextAreaElement> }}
    />
  );
});
